import { CombinatoriaI } from "interfaces/Combinatoria";
import React, { ReactNode } from "react";

interface Props {
  elemento: CombinatoriaI;
  renderActions?: (elemento: CombinatoriaI) => ReactNode;
}

export const CombinatoriaRow = ({ elemento, renderActions }: Props) => {
  return (
    <>
      <tr className="table-row" key={`ResolucionTable-${elemento.id}`}>
        <td>{elemento.id}</td>
        <td>{elemento.modalidad.nombre}</td>
        <td>{elemento.nivel.nombre}</td>
        <td>{elemento.opcion_pedagogica.nombre}</td>
        {renderActions && <td>{renderActions(elemento)}</td>}
      </tr>
    </>
  );
};
